import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../css/news.css';
import { Link } from "react-router-dom";
import { formatDate } from '../utils/dateUtils.js';
import truncate from 'html-truncate';
import DOMPurify from 'dompurify';
import api from "../api";

const RecentPosts = () => {
    const [recentPosts, setRecentPosts] = useState([]);
    const [bestPost, setBestPost] = useState(null);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const truncateContent = (html, length) => {
        return truncate(html, length, { ellipsis: '...' });
    };

    const loadBestPost = () => {
        return api
            .get(`${process.env.REACT_APP_API_URL}/api/posts/best-of-week`)
            .then((response) => {
                if (response.data && response.data.status === 'approved') {
                    setBestPost(response.data);
                    return response.data.id;
                }
                return null;
            })
            .catch((error) => {
                setBestPost(null);
                return null;
            });
    };

    const loadRecentPosts = (excludeId = null) => {
        setLoading(true);
        api
            .get(`${process.env.REACT_APP_API_URL}/api/posts?page=1&limit=5`)
            .then((response) => {
                if (response.data && Array.isArray(response.data)) {
                    const approvedPosts = response.data.filter(
                        (post) => post.status === 'approved' && post.id !== excludeId
                    );
                    setRecentPosts(approvedPosts.slice(0, 10));
                } else {
                    setRecentPosts([]);
                }
            })
            .catch((error) => {
                setRecentPosts([]);
            })
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadBestPost().then((bestPostId) => {
            loadRecentPosts(bestPostId);
        });
    }, []);

    if (loading) {
        return <p>{t('posts.loadingPosts')}</p>;
    }

    return (
        <aside className="recent-posts">
            <h2>{t('news.recentPosts') || 'Recent Posts'}</h2>
            {bestPost && (
                <div key={bestPost.id} className="recent-post-item best-post">
                    <strong>{t('posts.bestPostOfTheWeek')}:</strong>{' '}
                    <div className="post-data">
                        <span className="recent-post-user">{bestPost.username}</span>
                        <span className="recent-post-date">
                    {formatDate(bestPost.created_at, {format: 'LL'})}
                </span>
                    </div>
                    <Link to={`/posts/${bestPost.id}`} className="recent-post-content-link">
                        <div
                            className="recent-post-content"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(truncateContent(bestPost.content, 50)),
                            }}
                        />
                    </Link>
                </div>
            )}
            {recentPosts.map((post) => (
                <div key={post.id} className="recent-post-item">
                    <div className="post-data">
                        <span className="recent-post-user">{post.username}</span>
                        <span className="recent-post-date">
                    {formatDate(post.created_at, {format: 'LL'})}
                </span>
                    </div>
                    <Link to={`/posts/${post.id}`} className="recent-post-content-link">
                        <div
                            className="recent-post-content"
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(truncateContent(post.content, 50)),
                            }}
                        />
                    </Link>
                </div>
            ))}
        </aside>
    );
};

export default RecentPosts;
